import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Column, Row} from '../../components/layout';
import * as fonts from '../../util/fonts';
import './styles.scss';
import {useHistory, useLocation} from 'react-router-dom';
import colors from '../../util/colors';
import {functionalitiesAliasMap, strings} from '../../util/strings';
import ClaimItemsFilter, {
  ClaimItemsFilterProps,
} from '../reimbursements/components/ClaimItemsFilter';
import moment from 'moment';
import AppointmentsList from './components/appointments-list/AppointmentsList';
import {get} from '../../api/api';
import {
  uriGetAppointment,
  uriGetAppointmentsPast,
  uriGetAppointmentsUpcoming,
  uriGetUserConsents,
  uriUserBuOnlineOnly,
} from '../../api/endpoints';
import Icon from '../../components/icon';
import {Icons} from '../../util/icons';
import AppSpinner from '../../components/app-spinner';
import Header1 from '../../components/headers/header1';
import AppButton from '../../components/app-button';
import ModalTemplate from '../../components/modal';
import AppointmentsPermissions from './components/appointments-permissions-popup/AppointmentsPermissions';
import AppointmentDetails from '../appointment-details';
import AppointmentsScheduleCapPopup from './components/appointments-schedule-cap-popup/AppointmentsScheduleCapPopup';
import {ITenant} from '../../App';

interface AppointmentsProps {
  buStyles: any;
  selectedBu: any;
  labels: typeof strings.pt.appointments;
  labelsOneTrust: typeof strings.pt.oneTrust;
  user: any;
  busFuncMapDefault: any;
  tenant: ITenant;
}

enum Bu {
  notClient = 'NOTCLIENT',
}

function Appointments({
  buStyles,
  selectedBu,
  labels,
  user,
  labelsOneTrust,
  busFuncMapDefault,
  tenant,
}: AppointmentsProps) {
  const [filterShouldRefresh, setFilterShouldRefresh] = useState(false);
  const [appointmentsUpcoming, setAppointmentsUpcoming]: any = useState([]);
  const [appointmentsPast, setAppointmentsPast]: any = useState([]);
  const [upcomingEmpty, setUpcomingEmpty] = useState(false);
  const [pastEmpty, setPastEmpty] = useState(false);
  const [isLoadingPast, setIsLoadingPast] = useState(false);
  const [isLoadingUpcoming, setIsLoadingUpcoming] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showGeneralError, setShowGeneralError] = useState(false);
  const [patientList, setPatientList] = useState<any>([{}]);
  const [bypassPermissions, setBypassPermissions] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [appointmentStartError, setAppointmentStartError] = useState(false);
  const [appointmentSlugFromLocation, setAppointmentSlugFromLocation] =
    useState();
  const [appointmentIdFromLocation, setAppointmentIdFromLocation] =
    useState(null);
  const [appointmentProviderFromLocation, setAppointmentProviderFromLocation] =
    useState('');
  const [startTimer, setStartTimer] = useState(false);

  const featureName = 'AppointmentsHistory';
  const history = useHistory();
  const location: any = useLocation();

  //consents
  const [termsMain, setTermsMain] = useState(false);
  const [clinicConsent, setClinicConsent] = useState(false);
  const [clinicPolitica, setClinicPolitica] = useState(false);
  const [clinicEnquadramento, setClinicEnquadramento] = useState(false);
  const [showPermissionsModal, setShowPermissionsModal] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [patientListSet, setPatientListSet] = useState(false);
  const [oneTrustIsVisible, setOneTrustIsVisible] = useState(
    busFuncMapDefault?.[functionalitiesAliasMap.oneTrust]
  );

  const checkConsents = !oneTrustIsVisible
    ? true
    : (labelsOneTrust?.porpose_clinic_terms_main_show === 'true'
        ? termsMain
        : true) &&
      (labelsOneTrust?.porpose_clinic_consentimento_show === 'true'
        ? clinicConsent
        : true) &&
      (labelsOneTrust?.porpose_clinic_politica_show === 'true'
        ? clinicPolitica
        : true) &&
      (labelsOneTrust?.porpose_clinic_enquadramento_show === 'true'
        ? clinicEnquadramento
        : true);

  const filterParameterChanged = (
    filterParameter: string,
    ParameterValue: string | Date
  ) => {
    var newFilter = {...filter};
    (newFilter as any)[filterParameter] = ParameterValue;
    setFilter(newFilter);
    setFilterShouldRefresh(true);
  };

  let filterProps: ClaimItemsFilterProps = {
    controlLabels: {
      filterParmOne: 'Especialidade',
      filterDateFrom: 'Período',
    },
    filterOneOptions: [],
    filterParmOne: '',
    periodFrom: moment().subtract(6, 'month').toDate(),
    periodTill: moment().toDate(),
    filterParameterChanged: filterParameterChanged,
    filtersHaveChanged: filterShouldRefresh,
  };

  const [filter, setFilter] = useState<ClaimItemsFilterProps>(filterProps);

  const isNotClient = selectedBu.buId === Bu.notClient;
  const clientMemId = isNotClient ? user.nif : selectedBu.memId;

  const scrollToTab = () => {
    window.scroll({top: 0, behavior: 'smooth'});
  };

  useEffect(() => {
    if (!isLoadingPast && !isLoadingUpcoming) {
      scrollToTab();
      setStartTimer(true);
    }
  }, [isLoadingUpcoming, isLoadingPast]);

  useEffect(() => {
    if (startTimer) {
      const search = appointmentsUpcoming.find(
        (el: any) => el.status === 'booked' || 'pending' || 'checkedin'
      );

      if (search) {
        var handle = setInterval(() => getAppointmentsUpcoming(false), 10000);

        return () => {
          clearInterval(handle);
        };
      }
    }
  });

  const getAppointmentsUpcoming = async (loading: boolean) => {
    try {
      setIsLoadingUpcoming(loading);
      await get(
        uriGetAppointmentsUpcoming(selectedBu.buId, clientMemId),
        false,
        0,
        featureName
      ).then((res: any) => {
        res.data?.items?.length === 0
          ? setUpcomingEmpty(true)
          : setAppointmentsUpcoming(res.data?.items);
      });
    } catch (err) {
      setUpcomingEmpty(true);
    } finally {
      setIsLoadingUpcoming(false);
    }
  };

  const handleStartAppointment = async () => {
    try {
      await get(
        uriGetAppointment(
          appointmentIdFromLocation,
          appointmentProviderFromLocation
        ),
        false,
        0,
        featureName
      ).then((res: any) => {
        window.open(res.data.link, '_blank')?.focus();
      });
    } catch {
      setAppointmentStartError(true);
    }
  };

  const getAppointmentsPast = async () => {
    try {
      setIsLoadingPast(true);
      await get(
        uriGetAppointmentsPast(selectedBu.buId, clientMemId),
        false,
        0,
        featureName
      ).then((res: any) => {
        res.data?.items?.length === 0
          ? setPastEmpty(true)
          : setAppointmentsPast(res.data?.items);
      });
    } catch {
      setPastEmpty(true);
    } finally {
      setIsLoadingPast(false);
    }
  };

  useEffect(() => {
    setPastEmpty(false);
    setUpcomingEmpty(false);
    getAppointmentsUpcoming(true);
    getAppointmentsPast();
    setRefresh(false);
  }, [selectedBu.memId]);

  useEffect(() => {
    if (refresh) {
      setPastEmpty(false);
      setUpcomingEmpty(false);
      getAppointmentsUpcoming(true);
      getAppointmentsPast();
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    if (location?.state?.appointmentId) {
      setAppointmentIdFromLocation(location.state.appointmentId);
      setAppointmentProviderFromLocation(location.state.providerId);
      setAppointmentSlugFromLocation(location.state.specialty);
      setShowDetailsModal(true);
      window.history.replaceState({}, document.title);
    }
  }, []);

  const getPatientList = async () => {
    try {
      await get(
        uriUserBuOnlineOnly(user.nif, user.birthdate, true),
        false,
        0,
        featureName
      ).then((res: any) => {
        if (res) {
          setPatientList(res?.data?.products);
          setPatientListSet(true);
        }
      });
    } catch {
      setShowError(true);
    }
  };

  const getPurposes = async () => {
    try {
      await get(uriGetUserConsents(user.nif), false, 0, featureName).then(
        (res: any) => {
          const termsMainData = res?.data?.items[0].purposes.find(
            (element: any) =>
              element.id === labelsOneTrust?.porpose_clinic_terms_main
          );
          if (
            termsMainData &&
            termsMainData.version ===
              parseInt(labelsOneTrust?.version_porpose_terms_main) &&
            termsMainData.status === 'ACTIVE'
          ) {
            setTermsMain(true);
            res?.data?.items[0].purposes.forEach((element: any) => {
              if (element.id === labelsOneTrust?.porpose_clinic_consentimento) {
                setClinicConsent(element.status === 'ACTIVE');
              } else if (
                element.id === labelsOneTrust?.porpose_clinic_politica
              ) {
                setClinicPolitica(element.status === 'ACTIVE');
              } else if (
                element.id === labelsOneTrust?.porpose_clinic_enquadramento
              ) {
                setClinicEnquadramento(element.status === 'ACTIVE');
              }
            });
          }
        }
      );
      setLoaded(true);
    } catch (e: any) {
      setShowPermissionsModal(true);
    }
  };

  const handleOnScheduleAppointmentClick = () => {
    if (user.state === 'NOTCLIENT' || user.state === 'NOT_FOUND') {
      setPatientList([
        {
          buId: '',
          name: user.name,
        },
      ]);
      setPatientListSet(true);
    } else {
      getPatientList();
    }
  };

  useEffect(() => {
    if (!oneTrustIsVisible || loaded) {
      setLoaded(false);
      if (checkConsents || bypassPermissions) {
        if (patientList.length > 0) {
          history.push({
            pathname: '/consultas-online/marcar-consulta',
            state: {
              patientList: patientList,
              editingAppointmentId: undefined,
            },
          });
        } else {
          setShowGeneralError(true);
        }
      } else {
        setShowPermissionsModal(true);
      }
    }
    setBypassPermissions(false);
  }, [loaded]);

  useEffect(() => {
    if (patientListSet) {
      setPatientListSet(false);
      if (
        patientList.length === 1 ||
        user.state === 'NOTCLIENT' ||
        user.state === 'NOT_FOUND'
      ) {
        if (
          upcomingEmpty ||
          appointmentsUpcoming.length <
            labels?.appointments_schedule_upcoming_limit_default
        ) {
          oneTrustIsVisible && getPurposes();
        } else {
          setShowError(true);
        }
      } else {
        oneTrustIsVisible && getPurposes();
      }
    }
  }, [patientListSet]);

  return (
    <>
      <Row className="appointments-title-row appointments-row">
        <Column className="appointments-title-column">
          <Header1
            className="reimbursement-history-heading1"
            style={{...fonts.XL, ...fonts.Bold}}>
            {labels?.appointments_history_title}
          </Header1>
          <label style={{...fonts.M}}>
            {labels?.appointments_history_subtitle}
          </label>
        </Column>

        <Column className="appointments-schedule-button appointment-profile-column">
          <AppButton
            variant="primary"
            disabled={isLoadingPast || isLoadingUpcoming}
            onClick={() => handleOnScheduleAppointmentClick()}
            className="appointments-schedule-button-content">
            {labels?.appointments_schedule_appointment}
          </AppButton>
        </Column>
      </Row>

      {!isLoadingPast && !isLoadingUpcoming && false && (
        <Row className="filter-container-row reimbursement-history-row reimbursement-history-row-filter">
          <ClaimItemsFilter
            filterParmOne={filter.filterParmOne}
            periodFrom={filter.periodFrom}
            periodTill={filter.periodTill}
            filterParameterChanged={filterParameterChanged}
            filterOneOptions={['kek']}
            controlLabels={{
              ['filterParmOne']: 'Especialidade',
              ['filterDateFrom']: 'Período',
            }}
            filtersHaveChanged={false}></ClaimItemsFilter>
        </Row>
      )}
      {!isLoadingPast && !isLoadingUpcoming && !upcomingEmpty && (
        <div className="appointments-container">
          <Row>
            <Column className="appointments-next-appointments semibold">
              {labels?.appointments_next_appointments}
            </Column>
          </Row>
          <Row className="appointments-list">
            <AppointmentsList
              appointmentsItems={appointmentsUpcoming}
              borderColor={buStyles.primaryColor}
              setRefresh={setRefresh}
            />
          </Row>
        </div>
      )}
      {!isLoadingPast && !isLoadingUpcoming && !pastEmpty && (
        <div className="appointments-container">
          <Row>
            <Column className="appointments-next-appointments semibold">
              {labels?.appointments_previous_appointments}
            </Column>
          </Row>
          <Row className="appointments-list">
            <AppointmentsList
              appointmentsItems={appointmentsPast}
              borderColor={colors.lighterGrey}
              setRefresh={setRefresh}
            />
          </Row>
        </div>
      )}
      {!isLoadingPast && !isLoadingUpcoming && pastEmpty && upcomingEmpty && (
        <Column className="no-appointments-column">
          <Icon
            className="reimbursement-no-results-history-filter-icon"
            name={Icons.ALERT_PROBLEM}
            color={colors.lightGrey}
            width="40"
            height="40"
            changeViewbox
            viewBox={'0 0 24 24'}
          />
          <h6
            className="reimbursement-list-header"
            style={{color: colors.lightGrey}}>
            {labels?.appointments_no_results}
          </h6>
        </Column>
      )}
      <ModalTemplate
        className="appointment-cancel-container"
        contentClassName="appointment-cancel-content"
        show={showGeneralError}
        onHide={() => {
          setShowGeneralError(false);
        }}
        cross={true}
        hideFooter={true}
        size="sm">
        <div className="modal-error-container">
          <Row className="my-profile-submit-button-row">
            <Icon
              name={Icons.ALERT_PROBLEM}
              width={'40'}
              height={'40'}
              color={colors.alertRed}
              changeViewbox={false}
            />
          </Row>
          <Row className="errorPopup-title-row">
            <p
              style={{...fonts.MM, ...fonts.Bold, color: colors.alertRed}}
              className="p-errorPopup">
              {showGeneralError && labels?.appointments_error}
            </p>
          </Row>
          <Row className="my-profile-submit-button-row">
            <AppButton
              title="Ok"
              variant="primary"
              onClick={() => {
                setShowGeneralError(false);
              }}>
              Ok
            </AppButton>
          </Row>
        </div>
      </ModalTemplate>
      <AppointmentsScheduleCapPopup
        show={showError}
        setShowModal={setShowError}
      />
      <AppointmentDetails
        showDetailsModal={showDetailsModal}
        setShowDetailsModal={setShowDetailsModal}
        selectedAppointmentId={appointmentIdFromLocation}
        selectedAppointmentProviderId={appointmentProviderFromLocation}
        borderColor={buStyles.primaryColor}
        setRefresh={setRefresh}
        handleStartAppointment={handleStartAppointment}
        slugFromLocation={appointmentSlugFromLocation}
      />
      <AppointmentsPermissions
        show={showPermissionsModal}
        setShowModal={setShowPermissionsModal}
        setBypassPermissions={setBypassPermissions}
        patientList={patientList}
      />
      <ModalTemplate
        className="appointment-starting-error-modal"
        inputType="confirm"
        show={appointmentStartError}
        onHide={() => {
          setAppointmentStartError(false);
        }}
        cross={true}
        hideFooter={true}
        size="sm">
        <div className="modal-error-container">
          <Row className="my-profile-submit-button-row">
            <Icon
              name={Icons.ALERT_PROBLEM}
              width={'40'}
              height={'40'}
              color={colors.alertRed}
              changeViewbox={false}
            />
          </Row>
          <Row className="errorPopup-title-row">
            <p
              style={{...fonts.MM, ...fonts.Bold, color: colors.alertRed}}
              className="p-errorPopup">
              {labels?.appointments_error}
            </p>
          </Row>
          <Row className="my-profile-submit-button-row">
            <AppButton
              title="Ok"
              variant="primary"
              onClick={() => {
                setAppointmentStartError(false);
              }}>
              Ok
            </AppButton>
          </Row>
        </div>
      </ModalTemplate>
      {(isLoadingPast || isLoadingUpcoming) && (
        <AppSpinner
          style={{
            width: 'fit-content',
            margin: 'auto',
            marginBottom: '10%',
          }}
        />
      )}
    </>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  stringsDefault,
  globalStyles,
  busFuncMapDefault,
  tenant,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  buStyles: globalStyles.value,
  labels: strings.value.pt.appointments,
  labelsOneTrust: stringsDefault.value.pt.oneTrust,
  busFuncMapDefault: busFuncMapDefault.value,
  tenant: tenant.value,
});

export default compose(connect(mapStateToProps)(Appointments));
